module.exports = __webpack_public_path__ + "img/ar10.fffaaced.jpg";